import { gql } from "@apollo/client";

const ALL_PLATFORMS_ORGANIZATION = gql`
  query allOrganizationPlatforms(
    $filter: ListOrganizationPlatformsInput!
    $page: Int
    $limit: Int
    $search: String
  ) {
    allOrganizationPlatforms(filter: $filter, page: $page, limit: $limit, search: $search)
  }
`;

export default ALL_PLATFORMS_ORGANIZATION;
